import { useState } from "react";
import { useTranslation } from "react-i18next";
import { getApiInstance } from "../../../utils/api";
import Button from "../../common/Button/Button";
import Input from "../../common/Inputs/Input/Input";
import { FaCheckCircle } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import "./ForgotPassword.scss";

const ForgotPassword = ({ onSuccess, onCancel }) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const api = getApiInstance();
      const formData = new URLSearchParams();
      formData.append("email", email);

      await api.post("api/Auth/SendEmailForgotPassword", formData, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
      setSuccess(true);
      if (onSuccess) {
        setTimeout(() => onSuccess(), 2000);
      }
    } catch (err) {
      setError(err.response?.data?.message || t("forgotPassword.error"));
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="forgot-password__success">
        <FaCheckCircle className="forgot-password__success__icon" />
        <h2>{t("forgotPassword.successTitle")}</h2>
        <p>{t("forgotPassword.successMessage")}</p>
        <Button variant="filled" onClick={onSuccess}>
          Volver al inicio de sesión
        </Button>
      </div>
    );
  }

  return (
    <div className="forgot-password">
      <div className="forgot-password__header">
        <MdEmail className="forgot-password__header__icon" />
        <h2>{t("forgotPassword.title")}</h2>
      </div>

      <p className="forgot-password__subtitle">
        {t("forgotPassword.subtitle")}
      </p>

      <form onSubmit={handleSubmit} className="forgot-password__form">
        <Input
          type="email"
          label={t("forgotPassword.emailLabel")}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={t("forgotPassword.emailPlaceholder")}
          required
          disabled={loading}
        />

        {error && <div className="forgot-password__error">{error}</div>}

        <Button
          type="submit"
          variant="filled"
          disabled={loading || !email}
          loading={loading}
        >
          {t("forgotPassword.submit")}
        </Button>

        {onCancel && (
          <button
            type="button"
            className="forgot-password__back"
            onClick={onCancel}
          >
            Volver al inicio de sesión
          </button>
        )}
      </form>
    </div>
  );
};

export default ForgotPassword;
